export default {
  baseUrl: 'https://yasyadong.cc',
  imgPath: '/img/',
  filePreview: 'https://shorts.yasyadong.cc/static/uploads/'
}
const BASE_URL_MAP = {
  DEV: '/',
  PROD: 'https://shorts.yasyadong.cc',
  GP_PAGES: '/',
  GITEE_PAGES: '/',
  UNI: '/"'
}
export const IS_SUB_DOMAIN = ['GITEE_PAGES', 'GP_PAGES'].includes(import.meta.env.VITE_ENV)
export const IS_GITEE_PAGES = ['GITEE_PAGES'].includes(import.meta.env.VITE_ENV)
export const BASE_URL = BASE_URL_MAP[import.meta.env.VITE_ENV]
export const IMG_URL = BASE_URL + '/images/'
export const FILE_URL = BASE_URL + '/data/'
export const IS_DEV = process.env.NODE_ENV !== 'production'
